


































































































































































import Vue from "vue";
import { mapMutations, mapState } from "vuex";
import { AdvertiserEntry } from "@/interfaces/advertiserentry";
import _ from "lodash";
import Api from "@/api/Api";

export default Vue.extend({
  //   components: { AdvertisementForm, AdvertisementPreview },
  methods: {
    async confirm() {
      this.errors = {};
      this.isLoading = true;
      const postData: Record<string, any> = {};
      for (const [k, v] of Object.entries(this.advertiserEntry)) {
        if (_.isPlainObject(v) && (v as any)["@id"]) {
          postData[k] = (v as any)["@id"];
        } else {
          postData[k] = v;
        }
      }
      const decorated = await this.decoratePostData(postData);

      try {
        await Api.singleton().call({
          method: "POST",
          resource: "/api/adv/advertiser_entries/validate",
          body: decorated
        });
        this.phase = "confirm";
      } catch (violations) {
        for (const v of violations as Array<{
          propertyPath: string;
          message: string;
        }>) {
          this.$set(this.errors, v.propertyPath, v.message);
        }
      }
      this.isLoading = false;
    },
    async exec() {
      this.errors = {};
      this.isLoading = true;
      const postData: Record<string, any> = {};
      for (const [k, v] of Object.entries(this.advertiserEntry)) {
        if (_.isPlainObject(v) && (v as any)["@id"]) {
          postData[k] = (v as any)["@id"];
        } else {
          postData[k] = v;
        }
      }
      const decorated = await this.decoratePostData(postData);

      try {
        const ret = (await Api.singleton().call({
          method: "POST",
          resource: "/api/adv/advertiser_entries",
          body: decorated
        })) as object & { id: string };
        this.phase = "confirm";
        this.$router.push({
          name: "AdvertiserCreated"
        });
      } catch (violations) {
        for (const v of violations as Array<{
          propertyPath: string;
          message: string;
        }>) {
          this.$set(this.errors, v.propertyPath, v.message);
        }
      }
      this.isLoading = false;
    },
    async decoratePostData(postData: Record<string, unknown>) {
      return postData;
    }
  },
  computed: {
    ...mapState(["prefectures"])
  },
  data() {
    return {
      isLoading: false,
      phase: "input",
      errors: {},
      advertiserEntry: {}
    };
  },
  mounted() {
    this.$store.dispatch("fetchPrefectures");
  }
});
